module.exports = __webpack_public_path__ + "static/lecture-enfants-1200-ae605cf08ed6fd05c6a5d71d7875ba2a.jpg";